import { FEATURE_IDS } from "../constants/featureAccess";

export const isFeatureEnabled = (features, featureId) => {
  if (!features || !Array.isArray(features)) {
    return false;
  }

  const feature = features.find((f) => f.feature_id === featureId);
  return feature ? feature.status === "E" : false;
};

export const hasMetricsReporting = (features) =>
  isFeatureEnabled(features, FEATURE_IDS.METRICS_REPORTING);

/**
 * Resolve the admin post-login landing route based on plan features and preference.
 * @param {Array} features
 * @returns {string}
 */
export const resolveAdminLandingPage = (features) => {
  if (!hasMetricsReporting(features)) {
    return "/admin/scheduled-events";
  }

  return "/admin/dashboard";
};

export const hasAddOctoLinkWebsite = (features) =>
  isFeatureEnabled(features, FEATURE_IDS.ADD_OCTOLINK_WEBSITE);
